<template>
  <div class="up-teaching-plan">

    <HeadBtn :searchList='searchList' @addBtn='addBtn' @resetBtn="resetBtn" :defaultProps='defaultProps'
      :searchForm='searchForm' @searchFormData='searchFormData' :selectDict='selectDict' />

    <AddResource @addSuccess='addSuccess' :rowData='rowData' :type='type'
      :centerDialogVisible.sync='centerDialogVisible' :form='form' :selectDict='selectDict' />
    <Table :tableData='tableData' :tableHeadList='tableHeadList' :isBooks='false' @handleDelete='handleDelete' />
  </div>
</template>
<script>
import HeadBtn from "@/views/profile/components/mine/myUpload/common/HeadBtn";
import AddResource from "@/views/profile/components/mine/myUpload/common/AddResource";
import Table from "@/views/profile/components/mine/myUpload/common/Table";
import {
  getResourceAdmin,
  delResource,
  getDictBatch,
  IdGetResource
} from "@/network/resourceRequest/api";
import utils from "@/util/index";

export default {
  name: "UpCourseware",
  components: {
    HeadBtn,
    AddResource,
    Table
  },

  props: {
    //当前页面--------------------------------------------
    currentPage: {},
    //总页码--------------------------------------------
    pageTotal: {}
  },

  data() {
    return {
      tableData: [],
      //表格头部--------------------------------------------
      tableHeadList: [
        {
          prop: "name",
          label: "课件名称"
        },
        {
          prop: "course",
          label: "科目"
        },
        {
          prop: "phase",
          label: "学段"
        },
        {
          prop: "grade",
          label: "年级"
        },
        {
          prop: "edition",
          label: "版本"
        },
        {
          prop: "volume",
          label: "册别"
        }
      ],
      //筛选条件--------------------------------------------
      fd: {
        type: "课件",
        pageNum: 1,
        pageSize: 8
      },
      //搜索条件--------------------------------------------
      searchForm: {},

      //文件信息
      form: {
        name: "", //资源名称
        course: "", //科目
        phase: "", //学段
        grade: "", //年级
        volume: "", //册别
        edition: "", //版本
        chapterId: 0, //章节ID
        type: "课件",
        toll: "", //是否收费
        openState: 1, //公开状态
        fileId: "", //文件id凭证
        fileIdList: [], //文件id列表
        coverId: "", //封面id凭证
        id: 0, //资源id
        label: "" //标签属性
      },

      //渲染表单列表
      searchList: [
        {
          field: "name",
          type: "input",
          label: "资源名称：",
          placeholder: "填写资源名称"
        },
        {
          field: "phase",
          type: "option",
          label: "学段：",
          placeholder: "选择学段",
          optionList: []
        },
        {
          field: "course",
          type: "option",
          label: "科目：",
          placeholder: "选择科目",
          optionList: []
        },
        {
          field: "edition",
          type: "option",
          label: "版本：",
          placeholder: "选择册别",
          optionList: []
        },
        {
          field: "grade",
          type: "option",
          label: "年级：",
          placeholder: "选择年级",
          optionList: []
        },

        {
          field: "volume",
          type: "option",
          label: "册别：",
          placeholder: "选择册别",
          optionList: []
        },
        {
          field: "chapterId",
          type: "cascader",
          label: "章节：",
          placeholder: "选择章节(可不选)",
          optionList: []
        },
        {
          field: "toll",
          type: "option",
          label: "授权：",
          placeholder: "选择计费方式",
          optionList: [
            {
              value: 1,
              label: "免费"
            },
            {
              value: 2,
              label: "收费"
            }
          ]
        }
      ],

      //树形筛选结构
      defaultProps: {
        children: "children",
        label: "name",
        value: "id",
        emitPath: false
      },

      //添加还是修改
      type: "",
      //编辑的数据--------------------------------------------
      rowData: "",

      //筛选字典--------------------------------------------
      selectDict: [],

      //是否显示弹框
      centerDialogVisible: false
    };
  },

  created() {
    //初始化数据--------------------------------------------
    this._initData();
    this._getTableData();
  },

  watch: {
    currentPage(newPage) {
      this.$set(this.fd, "pageNum", newPage);
      this._getTableData();
    }
  },

  methods: {
    _initData() {
      //类型:course学科,phase学段,grade年级,volume册别,edition教材版本,textbook_label教材性质,qtype题型,rtype同步资源类型,ftype文件格式类型,ptype卷库类型
      let data = {
        types: "course,phase,grade,volume,edition"
      };
      getDictBatch(data).then(res => {
        if (res.data.success) {
          this.selectDict = res.data.data;
        }
      });
    },

    //添加按钮
    addBtn() {
      this.type = "add";
      this.centerDialogVisible = true;
    },

    //添加成功更新表格
    addSuccess() {
      this._getTableData();
    },

    //查询按钮返回的数据
    searchFormData(searchFormData) {
      this.fd = {
        type: "课件",
        pageNum: 1,
        pageSize: 8
      };
      for (const key in searchFormData) {
        if (
          searchFormData.hasOwnProperty(key) &&
          searchFormData[key] &&
          searchFormData[key] != "全部"
        ) {
          this.fd[key] = searchFormData[key];
        }
      }
      this._getTableData();
    },

    //重置表格数据
    resetBtn() {
      this.searchForm = {};
      this.fd = {
        type: "课件",
        pageNum: 1,
        pageSize: 8
      };
      this.$emit("update:currentPage", 1);
      this._getTableData();
    },

    //获取表格数据--------------------------------------------
    _getTableData() {
      getResourceAdmin(this.fd).then(res => {
        if (res.data.success) {
          this.tableData = res.data.data.list;
          this.$emit("update:pageTotal", res.data.data.total);
        } else {
          console.log("CoTextbook", res.data.code);
        }
      });
    },

    //取消收藏 (1编辑  2删除)
    handleDelete(scope, type) {
      //编辑
      if (type == 1) {
        IdGetResource("resource", scope.row.id).then(res => {
          this.rowData = res.data.data;
          this.type = "set";
          this.form.id = res.data.data.id;
          for (const key in this.form) {
            if (this.form.hasOwnProperty(key)) {
              this.$set(
                this.form,
                key,
                res.data.data.hasOwnProperty(key) ? res.data.data[key] : ""
              );
            }
          }
          this.centerDialogVisible = true;
        });
      }
      //删除
      if (type == 2) {
        delResource("resource", scope.row.id).then(res => {
          if (res.data.success) {
            utils.tips("success", res.data.code);
            //更新
            this._getTableData();
          } else {
            console.log("CoTextbook", res.data.code);
          }
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
</style>